import { render, staticRenderFns } from "./video-upload.vue?vue&type=template&id=77af909f"
import script from "./video-upload.vue?vue&type=script&lang=js"
export * from "./video-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports